// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_vS68g","loading":"loading_M0OEE","page":"page_fUlAy","ant-spin":"ant-spin"};